import { render, staticRenderFns } from "./WorkflowTaskSetup.vue?vue&type=template&id=5aa29c96&scoped=true"
import script from "./WorkflowTaskSetup.vue?vue&type=script&lang=js"
export * from "./WorkflowTaskSetup.vue?vue&type=script&lang=js"
import style0 from "./WorkflowTaskSetup.vue?vue&type=style&index=0&id=5aa29c96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa29c96",
  null
  
)

export default component.exports